export default __webpack_public_path__ + "static/B0217-7bce1fb516ffe1c424f126905c2018ff.png";